import styled from '@emotion/styled'

export const Container = styled.div`
  width: 100%;
`
